import { PostModel } from "common/models/baseModel";
import { create } from "zustand";

import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid";

import { IEventsGridFilter } from "../api_1/types";

export interface EventStore {
  postModel: PostModel<IEventsGridFilter>;
  handleFiltering: (filter: IEventsGridFilter) => void;
  handlePagination: (pageModel: GridPaginationModel) => void;
  handleSorting: (sortModel: GridSortModel) => void;
  // filterValues: IEventsGridFilter;
  // setFilterValues: (values: IEventsGridFilter) => void;
}

const useEventStore = create<EventStore>()((set) => ({
  postModel: {
    pagingModel: {
      page: 0,
      pageSize: 100,
    },
    filterModel: {
      eventTitle: null,
      eventCategoryID: null,
      eventDate: null,
      eventStatus: null,
      registrationStartDate: null,
      registrationEndDate: null,
    },
  },
  // filterValues: {
  //   eventTitle: null,
  //   eventCategoryID: null,
  //   eventDate: null,
  //   eventStatus: null,
  //   registrationStartDate: null,
  //   registrationEndDate: null,
  // },
  handlePagination: (pageModel: GridPaginationModel) =>
    set((state) => ({
      postModel: { ...state.postModel, pagingModel: { ...pageModel } },
    })),
  handleFiltering: (filterModel: IEventsGridFilter) =>
    set((state) => ({
      postModel: { ...state.postModel, filterModel: { ...filterModel } },
    })),
  handleSorting: (sortModel: GridSortModel) =>
    set((state) => ({
      postModel: { ...state.postModel, sortModel: [...sortModel] },
    })),
  // setFilterValues: (values) => set({ filterValues: values }),
}));

export default useEventStore;
